module.exports = __webpack_public_path__ + "img/shopify.64648c0e.png";